import { Users, ThumbsUp, Clock } from "lucide-react";

export const LandingImpact = () => {
  const stats = [
    {
      icon: Users,
      number: "+100 mil",
      description: "pessoas beneficiadas",
    },
    {
      icon: ThumbsUp,
      number: "91%",
      description: "dos usuários consideram a KopfAI útil",
    },
    {
      icon: Clock,
      number: "45%",
      description: "de redução de tempo perdido por ruídos mentais",
    },
  ];

  return (
    <section className="relative w-full min-h-[700px] flex flex-col items-center justify-center py-16 md:py-24 px-6 md:px-12 overflow-hidden">
      {/* Aqueous Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#D8DEE9]/40 via-white to-[#D8DEE9]/30 -z-10"></div>

      {/* Animated Blobs */}
      <div
        className="absolute top-20 right-[10%] w-[600px] h-[600px] rounded-full opacity-12 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(255, 209, 102, 0.6) 0%, rgba(255, 209, 102, 0) 70%)",
          animation: "float 22s ease-in-out infinite",
        }}
      ></div>
      <div
        className="absolute bottom-20 left-[10%] w-[500px] h-[500px] rounded-full opacity-10 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(74, 78, 105, 0.4) 0%, rgba(74, 78, 105, 0) 70%)",
          animation: "float 28s ease-in-out infinite reverse",
        }}
      ></div>

      <div className="max-w-6xl mx-auto w-full">
        <h2
          className="text-3xl md:text-4xl font-bold text-[#4A4E69] text-center mb-12"
          style={{
            animation: "fadeInUp 0.8s ease-out",
          }}
        >
          Sua confiança, nossos resultados
        </h2>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto mb-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="group relative bg-white/70 backdrop-blur-xl rounded-3xl p-8 border border-[#D8DEE9]/50 shadow-xl transition-all duration-500 hover:shadow-2xl hover:-translate-y-3 hover:border-[#FFD166]/50"
                style={{
                  animation: `fadeInUp 0.8s ease-out ${0.2 + index * 0.15}s backwards`,
                  boxShadow: "0 15px 50px rgba(74, 78, 105, 0.1)",
                }}
              >
                {/* Glow effect on hover */}
                <div
                  className="absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10 blur-2xl"
                  style={{
                    background: "radial-gradient(circle at 50% 0%, rgba(255, 209, 102, 0.4), transparent 70%)",
                  }}
                ></div>

                <div className="flex flex-col items-center text-center relative z-10">
                  {/* Icon Container */}
                  <div className="relative mb-6">
                    {/* Icon glow */}
                    <div
                      className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl"
                      style={{
                        background: "radial-gradient(circle, rgba(255, 209, 102, 0.8), transparent 70%)",
                        transform: "scale(2)",
                      }}
                    ></div>

                    <div className="relative w-16 h-16 rounded-2xl bg-gradient-to-br from-[#FFD166] to-[#FFD166]/80 flex items-center justify-center shadow-lg transition-all duration-500 group-hover:scale-110 group-hover:rotate-6">
                      <Icon className="w-8 h-8 text-[#4A4E69] transition-transform duration-500 group-hover:scale-110" />
                    </div>
                  </div>

                  {/* Number with gradient */}
                  <div className="text-4xl md:text-5xl font-extrabold mb-4 bg-gradient-to-br from-[#4A4E69] to-[#4A4E69]/80 bg-clip-text text-transparent transition-all duration-300 group-hover:scale-110">
                    {stat.number}
                  </div>

                  {/* Description */}
                  <p className="text-base md:text-lg text-[#272D37]/80 leading-relaxed font-medium">
                    {stat.description}
                  </p>
                </div>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#FFD166] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-b-3xl"></div>
              </div>
            );
          })}
        </div>

        {/* Texto informativo */}
        <div
          className="max-w-4xl mx-auto mt-4"
          style={{
            animation: "fadeInUp 0.8s ease-out 0.6s backwards",
          }}
        >
          <p className="text-base md:text-lg text-[#272D37]/85 leading-relaxed text-center">
            As ferramentas de IA da KopfAI demonstraram melhorar sintomas de transtornos como ansiedade, depressão,
            assim como estresse, além de ajudar na qualidade do sono e resiliência em momentos difíceis.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { 
            transform: translate(0, 0) scale(1); 
          }
          50% { 
            transform: translate(40px, 40px) scale(1.12); 
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};
